import React from "react";
import styles from "./MetricCard.module.css";
import type {MetricType, TournamentMetrics} from '@iziping/common';
import {useTranslation} from "react-i18next";

interface MetricCardProps {
  metric: TournamentMetrics;
}

export const MetricCard = ({ metric }: MetricCardProps) => {
  const {t} = useTranslation();
  const { label, type, value } = metric;

  const formatValue = (val: number, type: MetricType = "VALUE") => {
    switch (type) {
      case "PERCENT":
        return `${val.toFixed(1)}%`;
      case "VALUE":
        return new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR",
          maximumFractionDigits: 0,
        }).format(val);
      default:
        return new Intl.NumberFormat("fr-FR").format(val);
    }
  };

  return (
      <div className={styles.metricCard}>
        <div className={styles.metricLabel}>{t(`statistics.metrics.${metric.label}`)}</div>
        <div className={styles.metricValue}>{metric.value}</div>

      </div>
  );
};